import "leaflet";
document.addEventListener("turbo:load", () => {
  $("[data-decidim-map]").on("configure.decidim", (_ev, map, mapConfig) => {
    const tilesConfig = mapConfig.tileLayer;
    L.tileLayer(tilesConfig.url, tilesConfig.options).addTo(map);
  });
});
